import { Eye } from "lucide-react";
import { cn } from "@/lib/utils";

const SIZES = {
  sm: { icon: "h-4 w-4", title: "text-[12px]", fullform: "text-[8px]", tagline: "text-[10px]" },
  lg: { icon: "h-8 w-8", title: "text-xl", fullform: "text-[11px]", tagline: "text-sm" },
};

export function IrisBrand({
  compact = false,
  size = "sm",
  className,
  iconClassName = "text-muted-foreground",
  titleClassName = "text-foreground",
  subClassName = "text-muted-foreground",
  taglineClassName = "text-muted-foreground",
}) {
  const s = SIZES[size] || SIZES.sm;
  if (compact) {
    return <Eye className={cn(s.icon, iconClassName)} strokeWidth={1.75} />;
  }
  return (
    <div className={cn("flex flex-col items-center gap-0.5 text-center", className)}>
      <div className="flex items-center gap-1.5">
        <Eye className={cn(s.icon, "shrink-0", iconClassName)} strokeWidth={1.75} />
        <span className={cn(s.title, "font-semibold leading-tight tracking-wide", titleClassName)}>IRIS</span>
      </div>
      <p className={cn(s.fullform, "leading-tight", subClassName)}>Integrated Resource Intelligence &amp; Surveillance</p>
      <p className={cn(s.tagline, "italic leading-tight", taglineClassName)}>Iris is Watching</p>
    </div>
  );
}
